// eslint-disable-next-line max-classes-per-file
import lcrRequest from '../lcrRequest';

export class FourSightContentAPI {
  constructor(path, options) {
    this.url = path;
    this.matchId = options.matchId;
  }

  get() {
    if (!this.url) {
      return Promise.reject(new Error('FourSight content request is missing required data.'));
    }

    if (this.matchId === undefined || this.matchId === null) {
      return Promise.reject(new Error('FourSight content request is missing required matchId.'));
    }

    const requestUrl = `${this.url}?match_id=${encodeURIComponent(String(this.matchId))}`;

    return lcrRequest
      .get(requestUrl)
      .then(data => {
        if (!data || data.error) {
          throw data;
        }
        return data;
      })
      .catch(e => {
        throw new Error(`FourSight content API Request error: ${e}`);
      });
  }
}

export class FourSightContentRequest extends FourSightContentAPI {
  constructor(matchId) {
    super('/api/match-tickers', {
      matchId,
    });
  }
}
